export const DisplayState = {
    Idle: 'Idle',
    Scanning: 'Scanning',
    DriveAuthorized: 'DriveAuthorized',
    DriveUnlicensed: 'DriveUnlicensed',
    DriveWrongZone: 'DriveWrongZone',
    DeniedNoRight: 'DeniedNoRight',
    DeniedExpired: 'DeniedExpired',
    DeniedPoolFull: 'DeniedPoolFull',
    Full: 'Full',
    ExitIdle: 'ExitIdle',
    ExitFree: 'ExitFree',
    ExitViolations: 'ExitViolations',
    PaymentRequired: 'PaymentRequired',
    PaymentInProgress: 'PaymentInProgress',
    PaymentDone: 'PaymentDone',
    NoEntryRecord: 'NoEntryRecord',
    Emergency: 'Emergency',
    Maintenance: 'Maintenance',
    CustomMessage: 'CustomMessage',
    Fallback: 'Fallback',
} as const;

export type DisplayState = typeof DisplayState[keyof typeof DisplayState];
